document.addEventListener('DOMContentLoaded', function() {

    //Actualizar unidades por hora al cambiar ciclo o cavidades activas
    const modalCrearTurnoSoplado = document.querySelector('#modalCrearTurnoSoplado');

    if (!modalCrearTurnoSoplado) return;

    const inputCiclo = modalCrearTurnoSoplado.querySelector('input[id="ciclo"]');
    const inputCavActivas = modalCrearTurnoSoplado.querySelector('input[id="cavActivas"]');
    const inputUndHora = modalCrearTurnoSoplado.querySelector('input[id="undHora"]');

     if (!inputCiclo || !inputCavActivas || !inputUndHora) return;

    inputCiclo.addEventListener('input', calcularUndHora);
    inputCavActivas.addEventListener('input', calcularUndHora);

    function calcularUndHora() {
        const ciclo = parseFloat(inputCiclo.value);
        const cavidades = parseInt(inputCavActivas.value);

        if (isNaN(ciclo) || isNaN(cavidades) || ciclo <= 0 || cavidades <= 0) {
            inputUndHora.value = '';
            return;
        }

        const undHora = (3600 / ciclo) * cavidades;
        inputUndHora.value = Math.round(undHora).toLocaleString('en-US');
    }
});

// Submit via API
document.addEventListener('submit', async function (e) {
    if (e.target.id !== 'formularioCrearTurnoSoplado') return;

    e.preventDefault();

    const formulario = e.target;
    const btnSubmit  = formulario.querySelector('[type="submit"]');
    const spinner    = formulario.querySelector('#spinner');

    if (!formulario.checkValidity()) {
        formulario.reportValidity();
        return;
    }

    formulario.querySelectorAll('.inputRojo').forEach(el => el.classList.remove('inputRojo'));

    if (btnSubmit) btnSubmit.disabled = true;
    if (spinner)   spinner.style.display = 'inline-block';

    try {
        const formData = new FormData(formulario);

        const respuesta = await fetch('/api/soplado/crear-turno', {
            method: 'POST',
            body: formData,
            credentials: 'include'
        });

        let json = null;
        try {
            json = await respuesta.json();
        } catch {
            throw new Error('La respuesta del servidor no es JSON válido.');
        }

        if (!respuesta.ok) {
            lanzarAlerta('Error al procesar la solicitud.', 'alerta-roja');
            return;
        }

        const resultado = json.result;

        if (!resultado) {
            lanzarAlerta('Respuesta inesperada del servidor.', 'alerta-roja');
            return;
        }

        if (resultado.hayErrores) {
            if (Array.isArray(resultado.errores)) {
                resultado.errores.forEach(function (error) {
                    if (error.mensaje) {
                        lanzarAlerta(error.mensaje, error.clase || 'alerta-roja');
                    }
                    if (error.campo) {
                        const campo = formulario.querySelector('[name="' + error.campo + '"]');
                        if (campo) campo.classList.add('inputRojo');
                    }
                });
            }
            return;
        }

        const params = new URLSearchParams(window.location.search);
        const mes    = params.get('mes');
        const anio   = params.get('año');

        if (typeof window.actualizarTablaSopladoPeriodo === 'function') {
            window.actualizarTablaSopladoPeriodo(mes, anio);
        }

        if (typeof window.actualizarTableroSopladoPeriodo === 'function') {
            window.actualizarTableroSopladoPeriodo(mes, anio);
        }

        formulario.reset();

        const modal = formulario.closest('.modal');
        if (modal) modal.classList.remove('modal--show');

        lanzarAlerta('Reporte de soplado creado satisfactoriamente.', 'alerta-verde');

    } catch (error) {
        console.error('Error:', error);
        lanzarAlerta('Error crítico al procesar la solicitud.', 'alerta-roja');

    } finally {
        if (btnSubmit) btnSubmit.disabled = false;
        if (spinner)   spinner.style.display = 'none';
    }
});
